import { Component, Suspense, lazy, type ComponentType, type ComponentProps, type ReactNode } from 'react';
import { Carregando, Erro } from '../ui/Estados';

export class FalhaDeDownload extends Error {}

/** Falhas de download ficam na tela/ação/painel, preservando a navegação do shell. */
export class LimiteDaTela extends Component<{ children: ReactNode; acao?: boolean }, { erro: unknown }> {
  state: { erro: unknown } = { erro: null };

  static getDerivedStateFromError(erro: unknown) {
    return { erro };
  }

  render() {
    if (!this.state.erro) return this.props.children;
    if (this.props.acao) return null;
    return this.state.erro instanceof FalhaDeDownload
      ? <><p role="status">Não foi possível baixar a tela. Tente recarregar a página.</p><Erro aoTentar={() => window.location.reload()} /></>
      : <Erro erro={this.state.erro} />;
  }
}

type TelaDe<M, K extends keyof M> = Extract<M[K], ComponentType<any>>;

/** Mantém as props e adapta o export nomeado; o import só começa na renderização. */
export function telaSobDemanda<M, K extends keyof M>(carregar: () => Promise<M>, nome: K, acao = false): ComponentType<ComponentProps<TelaDe<M, K>>> {
  const Tela = lazy(() => carregar().then((modulo) => ({ default: modulo[nome] as TelaDe<M, K> })).catch((causa: unknown) => {
    throw new FalhaDeDownload('Falha ao baixar a tela', { cause: causa });
  })) as ComponentType<ComponentProps<TelaDe<M, K>>>;
  return function TelaSobDemanda(props: ComponentProps<TelaDe<M, K>>) {
    return (
      <LimiteDaTela acao={acao}>
        <Suspense fallback={acao ? null : <Carregando />}>
          <Tela {...props} />
        </Suspense>
      </LimiteDaTela>
    );
  };
}

/** A ação compartilha o chunk da tela, que já apresenta o erro ao usuário. */
export function acaoSobDemanda<M, K extends keyof M>(carregar: () => Promise<M>, nome: K): ComponentType<ComponentProps<TelaDe<M, K>>> {
  return telaSobDemanda(carregar, nome, true);
}
